import styled, { createGlobalStyle } from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  ACTIVITY_BUILDER_A4_SHORT_SIDE,
} from 'approot/activity-builder/activity-builder.constants';
import { spacing24 } from 'approot/shared/styles/spacing.style';

export const ActivityAnswersA4 = styled.div`
  background-color: ${grey1};
  @page {
    margin: 0;
    size: A4 landscape;
  }
`;

export const ActivityAnswersPage = styled.div`
  width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
  min-height: ${rem(ACTIVITY_BUILDER_A4_SHORT_SIDE)};
`;

export const A4GlobalStyles = createGlobalStyle`
  @page {
    margin: 0;
    size:  A4 landscape;
  }
`;

export const ActivityAnswersPageInner = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${rem(ACTIVITY_BUILDER_A4_SHORT_SIDE)};
`;

export const ActivityAnswersPageInnerContent = styled.div`
  flex-grow: 1;
  padding: ${rem(spacing24)};
`;
